import AddressFilter from "components/filters/Filters/AddressFilter";
import { CompanySortFilter } from "components/filters/Filters/SortFilter";
import FunctionGroupFilter from "components/filters/Filters/FunctionGroupFilter";
import KeywordFilter from "components/filters/Filters/KeywordFilter";
import OwnersFilter from "components/filters/Filters/OwnersFilter";
import StatusFilter from "components/filters/Filters/StatusFilter";
import TagFilter from "components/filters/Filters/TagFilter";
import React from "react";
import OnlyMySelectionFilter from "components/filters/Filters/OnlyMySelectionFilter";

interface FiltersProps {
  initialTags: server.dto.TagSmall[]
  initialStatuses: server.dto.StatusSmall[]
}

const Filters = (props: FiltersProps) => {
  return <>
    <KeywordFilter
      label={RESX.GeneralLabels.Search}
      title={RESX.GeneralLabels.Search}
      placeholder={RESX.GeneralLabels.Search}
    />
    <TagFilter
      mainArea="company"
      initialTags={props.initialTags}
    />
    <AddressFilter />
    {site.currentEnvironment.statuses.company.length > 1 && (
      <StatusFilter initialStatuses={props.initialStatuses} />
    )}
    <OwnersFilter />
    <FunctionGroupFilter />
    <CompanySortFilter />
    <OnlyMySelectionFilter />
  </>;
};

export default Filters;